import { Modal as MantineModal, type ModalProps as MantineModalProps } from '@mantine/core';
import { forwardRef } from 'react';

export type ModalProps = MantineModalProps;

export const Modal = forwardRef<HTMLDivElement, ModalProps>(function Modal(props, ref) {
  return <MantineModal ref={ref} centered withCloseButton {...props} />;
});
